<script setup>
import { DialogPortal, useForwardProps } from "reka-ui";

const props = defineProps({
  to: { type: [String, Object], default: undefined },
  disabled: { type: Boolean, default: false },
  defer: { type: Boolean, default: false },
  forceMount: { type: Boolean, default: false },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <DialogPortal v-bind="forwarded">
    <slot />
  </DialogPortal>
</template>
